import * as utils from './utils'
import * as utils_time from './utils_time'
import { BaseObject, MongoObject } from './_baseClasses'
import { crunchbase, crunchbaseSummary, gptResponse } from './docsend'

const DEBUGGING: boolean = false

export class doc extends MongoObject {
  protected static collectionName: string = 'docs'    // IMPORTANT

  // fields
  public docsendId: string = null
  public numPages: number = null
  public totalSize: number = null
  public isVertical: boolean = null
  public title: string = null
  public previewURL: string = null
  public imageBase64: string = null
  public authorName: string = null
  public authorEmail: string = null
  public authorDomain: string = null
  public deducedCompanyDomain: string = null
  public requestorIPs: string[] = null
  public text: string[] = null
  public fingerprint: string = null        // unique identifier for this doc
  public type: string = null               // startup deck, etc.. (manually set)
  public stage: string = null              // Seed, Series A, Series B, etc... (manually set)
  public notes: string = null
  public notesByUser: { [ userId: string ]: string } = {}
  public lastseen: Date = null
  public crunchbase?: crunchbase = null
  public crunchbaseSummary?: crunchbaseSummary = null

  public gptResponses?: gptResponse[] = null
  public gptRating?: number = null            // filled in fron the latest gptResponse

  // complex, class-based fields (require to be hydrated after loading from external sources like mongo or elastic)

  constructor(po?: object, docsendId?: string) {
    super()
    if (po) this.injectPlainObject(po)
    if (docsendId) {
      this.docsendId = docsendId
    }
    this.hydrate()
  }

  public getImageURL(): string {
    return `${utils.getURLprefix()}/api/docs/${this.getIdAsObjectId()}/pic`   // external reference to API (allows browser caching)
    // return `data:image/jpeg;base64, ${this.imageBase64}`                   // embed image on page
  }

  public getDeckURL(): string {
    return `${utils.getURLprefix()}/api/docs/${this.getIdAsObjectId()}/deck`
  }

  public getWhenViewed(): string {
    return utils.prettyTimeDiff(new Date().getTime() - this.lastseen.getTime()) + ' ago'
    // return utils.prettyDaysAgo(new Date().getTime() - this.lastModified.getTime())
  }

  public getAmountRaised(): string {
    if (this.crunchbaseSummary && this.crunchbaseSummary.total_funding_usd > 0) return utils.getDollarAmoundAbbreviation(this.crunchbaseSummary.total_funding_usd)
    return null
  }

  public getFoundedDate(): string {
    if (this.crunchbaseSummary.founded_on == null || this.crunchbaseSummary.founded_on.length === 0) return '?'
    const pieces: string[] = this.crunchbaseSummary.founded_on.split('-')
    if (pieces.length >= 3 && pieces[1] === '01' && pieces[2] === '01') return pieces[0]    // return only year
    return this.crunchbaseSummary.founded_on
  }

  public niceShortFirstSeen(): string {
    return utils_time.niceShortDateString(this.created)
  }
  public niceShortLastSeen(): string {
    return utils_time.niceShortDateString(this.lastseen)
  }

  public getLatestGptResponse(): gptResponse {
    if (this.gptResponses && this.gptResponses.length > 0) {
      return this.gptResponses[this.gptResponses.length - 1]
    }
  }

}

(async () => {
})();
